<template>
  <BadgeItem
    :name="name"
    :image-src="image"
    image-alt="achievement"
    :is-locked="isLocked"
    :has-badge="isRecurring"
    :badge-content="totalRecurring"
    @click="$emit('show:achievementDetails')"
  />
</template>

<script setup>
import { computed } from 'vue';
import BadgeItem from '@/views/profileOverview/components/item/BadgeItem.vue';
import { getAchievementBadgeImage, getAchievementNameTranslationKey } from '@/helpers/reward.js';

defineEmits(['show:achievementDetails']);

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
});

const name = computed(() => getAchievementNameTranslationKey(props.item.achievementName));
const image = computed(() => getAchievementBadgeImage(props.item.achievementName));
const isLocked = computed(() => !props.item.details.completed);
const isRecurring = computed(() => props.item.details.recurring);
const totalRecurring = computed(() => isRecurring.value ? props.item.details.recurringCounter : 0);
</script>
